// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"0a5f3d5b","556":"c275ef7f","805":"51e5a56f"}[chunkId] + ".chunk.js";
};